import Icon from "./icon.js";

const { redom } = window;
const { el } = redom;

export default class Navigate {
  constructor() {
    this.el = el(
      ".maplibregl-ctrl .maplibregl-ctrl-group",
      el(".maplibregl-ctrl-zoom-in", new Icon("plus"), {
        onclick: () => {
          this.action({ zoomIn: true });
        },
      }),
      el(".maplibregl-ctrl-zoom-out", new Icon("minus"), {
        onclick: () => {
          this.action({ zoomOut: true });
        },
      }),
      el(
        ".maplibregl-ctrl-compass",
        { style: { perspective: "1.5rem" } },
        (this.orientationIcon = new Icon("navigation-top")),
        {
          onclick: () => {
            this.action({ resetOrientation: true });
          },
        }
      )
    );
  }

  onAdd(map) {
    this.map = map;

    const orientate = () => {
      try {
        const bearing = map.getBearing();
        const pitch = map.getPitch();

        this.orientationIcon.el.style.transform = `rotateX(${
          (pitch * 2) / 3
        }deg) rotateZ(${-bearing}deg)`;
      } catch (err) {
        console.error(new Error(err));
      }
    };

    map.on("rotate", orientate);
    map.on("pitch", orientate);

    orientate();

    return this.el;
  }

  action({ zoomIn, zoomOut, resetOrientation }) {
    const { map } = this;

    if (zoomIn) {
      const zoom = Math.round(map.getZoom()) + 1;
      map.easeTo({ zoom });
    } else if (zoomOut) {
      const zoom = Math.round(map.getZoom()) - 1;
      map.easeTo({ zoom });
    } else if (resetOrientation) {
      map.easeTo({ bearing: 0, pitch: 0 });
    }
  }
}
